import {i18nStrict} from '~ui/utils/i18n';

import {en} from './en';
import {ru} from './ru';

export const i18n = i18nStrict({en, ru});
